import { css } from '../../../common.styles';
import { baseColor, mobile, primaryColor, primaryFont, secondaryColor } from '../../../styles/general/theme';
import {
  PrimaryBorderedSimpleButtonStyle,
  PrimaryButtonVersionBStyle,
  SimpleButtonStyle,
} from '../../button/citroen/cit-button';

const ButtonStyle = css`
  display: inline-flex;
  min-width: 285px;
  justify-content: center;

  @media (max-width: ${mobile}px) {
    min-width: 100%;
  }
`;

export const CitRichTextStyle = css<{
  disabled?: boolean;
  standardPro?: boolean;
  disableOverflow?: boolean;
  overFlowWrap?: string;
  removeTopMargin?: boolean;
}>`
  overflow: inherit;
  font-family: ${primaryFont};

  ul {
    margin: 0;
  }

  img {
    max-width: 100%;
  }

  @media (max-width: ${mobile}px) {
    img {
      padding: 0;
    }
  }

  .primary-button,
  .button-primary {
    ${SimpleButtonStyle};
    ${ButtonStyle};
    width: auto;
    background-color: ${(p) => (p.disabled ? baseColor(730) : primaryColor(200))};
    color: ${(p) => (p.disabled ? baseColor(500) : baseColor(900))};
  }

  .button-primary.b-version,
  .primary-button.b-version,
  .button-primary.grey {
    ${PrimaryButtonVersionBStyle};
    ${ButtonStyle};
    width: auto;
  }

  .secondary-button {
    ${PrimaryBorderedSimpleButtonStyle};
    ${ButtonStyle};
    color: ${primaryColor(200)};
    border: 1px solid ${primaryColor(200)};
    width: auto;

    :hover {
      background-color: ${primaryColor(200)};
      color: ${baseColor(900)};
    }
  }

  .secondary-button.b-version {
    ${PrimaryBorderedSimpleButtonStyle};
    ${ButtonStyle};
  }

  .primary-button.back,
  .secondary-button.back,
  .button-primary.back {
    ${PrimaryBorderedSimpleButtonStyle};
    ${ButtonStyle};
    color: ${primaryColor(200)};
    border: 1px solid ${primaryColor(200)};
    position: relative;
    overflow: hidden;
    top: 4px;

    :before {
      background-color: ${primaryColor(200)};
      content: '';
      height: 13px;
      left: 26px;
      position: absolute;
      top: 15px;
      transform: rotate(45deg);
      width: 13px;
    }

    :after {
      background-color: white;
      content: '';
      height: 13px;
      left: 28px;
      position: absolute;
      top: 15px;
      transform: rotate(45deg);
      width: 13px;
    }

    :hover {
      background-color: ${primaryColor(200)};
      color: ${baseColor(900)};

      :after {
        background-color: ${primaryColor(200)};
      }

      :before {
        background-color: ${baseColor(900)};
      }
    }
  }

  .richtext-popup-link,
  .link-primary {
    box-sizing: border-box;
    font-family: ${primaryFont};
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: ${primaryColor(200)};
    cursor: pointer;
    display: inline-block;
    width: fit-content;

    :after {
      display: inline;
      content: '>';
      height: 14px;
      width: 100%;
      margin-left: 10px;
      transform: translateY(-4px);
    }

    :hover {
      color: ${baseColor(250)};
    }

    :disabled {
      color: ${baseColor(500)};
    }
  }

  .link-secondary {
    box-sizing: border-box;
    font-family: ${primaryFont};
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: ${primaryColor(200)};
    cursor: pointer;

    :hover {
      color: ${baseColor(250)};
    }

    :disabled {
      color: ${baseColor(500)};
    }
  }

  .link-tertiary {
    box-sizing: border-box;
    font-family: ${primaryFont};
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    text-decoration: underline;
    color: ${primaryColor(200)};
    cursor: pointer;

    :hover {
      color: ${baseColor(250)};
    }

    :disabled {
      color: ${baseColor(500)};
    }
  }

  .richtext-tooltip {
    & svg {
      circle {
        stroke-width: 0.7;
        stroke: ${primaryColor(100)};
      }

      path {
        fill: ${primaryColor(100)};
        stroke-width: 0.5;
        stroke: ${primaryColor(100)};
      }
    }
  }

  ${(p) =>
    p.removeTopMargin &&
    css`
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-top: 0 !important;
      }
    `};

  ${(p) =>
    p.disableOverflow &&
    css`
      overflow: hidden;
    `};

  ${(p) =>
    p.standardPro &&
    css`
      td {
        padding: 10px;
        border-right: 3px solid ${baseColor(900)};

        &:last-child {
          border-right: none;
        }
      }

      tbody tr:first-child {
        background-color: ${primaryColor(200)};
        color: ${baseColor(900)};
        font-size: 14px;
        font-weight: 700;
      }

      tr {
        font-size: 14px;
        font-weight: 400;

        &:nth-child(odd) {
          background-color: ${baseColor(900)};
        }

        &:nth-child(even) {
          background-color: ${secondaryColor(850)};
        }
      }
    `};
`;
